import {
	getMessages as getMessagesRequest,
	getMessage as getMessageRequest,
	getUnreadCount as getUnreadCountRequest,
	markAsRead as markAsReadRequest,
} from "../../domain/messages"

// Action types
export const MESSAGES_SET = "MESSAGES_SET"
export const MESSAGES_APPEND = "MESSAGES_APPEND"
export const MESSAGE_SET = "MESSAGE_SET"
export const MESSAGES_REQUEST = "MESSAGES_REQUEST"
export const MESSAGES_REQUEST_DONE = "MESSAGES_REQUEST_DONE"
export const UNREAD_COUNT_SET = "UNREAD_COUNT_SET"
export const MESSAGE_MARK_READ = "MESSAGE_MARK_READ"

// Action creators
export const setMessages = data => ({ type: MESSAGES_SET, payload: data })

export const appendMessages = data => ({ type: MESSAGES_APPEND, payload: data })

export const setMessage = data => ({ type: MESSAGE_SET, payload: data })

export const messagesRequest = () => ({ type: MESSAGES_REQUEST })

export const messagesRequestDone = () => ({ type: MESSAGES_REQUEST_DONE })

export const setUnreadCount = count => ({ type: UNREAD_COUNT_SET, payload: count })

export const markMessageRead = id => ({ type: MESSAGE_MARK_READ, payload: id })

// Thunk actions
export const getMessages = (params = {}) => dispatch => {
	dispatch(messagesRequest())
	const requestParams = {
		page: params.page || 1,
		per_page: params.per_page || 15,
		...params,
	}
	return getMessagesRequest(requestParams).then(res => {
		dispatch(setMessages(res.data))
		dispatch(messagesRequestDone())
		return res.data
	})
}

export const getMessage = id => dispatch => {
	dispatch(messagesRequest())
	return getMessageRequest(id).then(res => {
		dispatch(setMessage(res.data.data))
		dispatch(messagesRequestDone())
		// Also update unread count since viewing marks as read
		dispatch(getUnreadCount())
		return res.data.data
	})
}

export const getUnreadCount = () => dispatch => {
	return getUnreadCountRequest().then(res => {
		dispatch(setUnreadCount(res.data.count))
		return res.data.count
	})
}

export const markAsRead = id => dispatch => {
	return markAsReadRequest(id).then(res => {
		dispatch(markMessageRead(id))
		dispatch(getUnreadCount())
		return res.data
	})
}
